import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { WsContentApi } from 'api/ApiHelper';

export const useWithdrawContestContentMutation = (contestId: number, contentId: number, options?: UseMutationOptions) =>
  useMutation({ mutationFn: () => WsContentApi.withdrawContest(contestId, contentId), ...options });
